export default __webpack_public_path__ + "static/weather--cloud-48a7a0204dbd4a166861ca1452ceb124.png";